import React, { useState } from 'react';
import { useFetchSerialLinkDataQuery } from '@modules/EnquiryForm/EnquiryForm.service';
import './SerialLink.scss';

interface SerialLinkProps {
  linkLabel: string;
}

export const SerialLink = ({ linkLabel }: SerialLinkProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const contactUsBlock = document.getElementById('ContactUsBlock');
  const pageId = contactUsBlock?.dataset?.data
    ? JSON.parse(contactUsBlock?.dataset?.data)?.pageId
    : window.pageId;
  const { data } = useFetchSerialLinkDataQuery({
    pageId: pageId,
  });
  const serialLink = data ? JSON.parse(data.JsonMessage) : null;

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (!linkLabel || !serialLink) {
    return null;
  }

  return (
    <>
      <label className='c-form-serial-link' onClick={openModal}>
        {linkLabel}
      </label>
      {serialLink && isModalOpen && (
        <div className='c-form-modal'>
          <div className='c-form-popup-container'>
            <div className='c-form-popup-header'>
              <p className='c-form-popup-title'>{serialLink.Title}</p>
              <span className='icon-symbol-close c-form-popup-close' onClick={closeModal}></span>
            </div>

            <div className='c-form-popup-body'>
              <div className='c-form-popup-body-left'>
                <img
                  src={serialLink.Image}
                  alt={serialLink.ImageAltText}
                  className='c-product-card'
                ></img>
              </div>

              <div
                className='c-form-popup-body-right'
                dangerouslySetInnerHTML={{
                  __html: serialLink.Description,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
